import { Feature } from "geojson"
import { getBoundaryColumns } from "../helpers/getBoundaryColumns"
import { boundaryLevelLookUp } from "../helpers/boundaryLevelLookup"
import { getFriendlyBoundaryName } from 'map-style-utils';
import msnameLookup from '../helpers/lookup.json'

type CoverageData = {
  "type": string
  "name": string
}

const DEFAULT_TYPE = "AdministrativeArea"
const DEFAULT_NAME = "Earth"

const DEFAULT_RETURN = {
  "type": DEFAULT_TYPE,
  "name": DEFAULT_NAME,
}


const typeLookup = (columnName: string) => {
  switch (columnName) {
    case 'MS_us-states':
    case 'MS_uk-regions':
      return 'State';
    case 'MS_zz-countries':
      return 'Country';
    default:
      return DEFAULT_TYPE;
  }
}

function isPropertySingularValue(geojsonFeatures: Feature[], property: string): boolean {
  const valueSet: Set<string> = new Set(
    geojsonFeatures
      .map((feature) => feature.properties![property])
      .filter(value => value && value !== null && value !== undefined)
  )

  return valueSet.size === 1
}

function genCoverageData(geojsonFeatures: Feature[]): CoverageData {

  const boundaryColumns: string[] = getBoundaryColumns(geojsonFeatures)
  let finalColumn: string = ''

  for (let i = 0; i < Object.keys(boundaryLevelLookUp).length; i++) {
    const possibleColumns = boundaryLevelLookUp[i]
    for (let col of possibleColumns) {
      if (boundaryColumns.includes(col) && isPropertySingularValue(geojsonFeatures, col)) {
        finalColumn = col
        //console.log(`final column is ${finalColumn}`)
      }
    }
  }

  //console.log(`final column still is ${finalColumn}`)
  if (finalColumn === '') return DEFAULT_RETURN;

  const valueSet: Set<string> = new Set(
    geojsonFeatures
      .map((feature) => feature.properties![finalColumn])
      .filter(value => value && value !== null && value !== undefined)
  )

  const type: string = typeLookup(finalColumn)
  const value: string = [...valueSet.values()][0]!
  const lookup: string = finalColumn.split('_')[1]!
  const name: string = msnameLookup[lookup][value]

  //console.log(`type is ${type}`)
  //console.log(`name was ${value}, now is ${name}`)

  return {
    "type": type,
    "name": name,
  }
}

export { genCoverageData }
